const NHS = {
  primary: '#005eb8',
  primaryLight: '#5996d1',
  onPrimary: '#ffffff',
  accent: '#5996d1',
}

const THEME = {
  NHS,
}

export default THEME
